import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveWorkLoads from "./retrieveWorkLoads";
import * as workLoadsChunks from "./workLoadsChunks";

const initialState: State = {
  retrieveWorkLoads: retrieveWorkLoads.initialState,
  workLoadsChunks: workLoadsChunks.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveWorkLoads: retrieveWorkLoads.reduceState,
  workLoadsChunks: workLoadsChunks.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveWorkLoads.createSelector(() => getState().retrieveWorkLoads),
    ...workLoadsChunks.createSelector(() => getState().workLoadsChunks),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
